import Char from "./chars/Char.js";
import PageCommon from "./PageCommon.js";

export default class PageManager extends PageCommon {
  constructor() {
    super();
  }
  init() {
    super.init();
    this.create();
  }

  create() {
    this.showPreloader(false);
    let char = new Char("assets/manager", PageManager.URL, { idle: 1, smile: 3, sad: 3, url: "sei.html" }, { idle: 1, smile: 1, sad: 3, url: "goth.html" })
    char.init();
  }


}


PageManager.URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQIW3vogwCspCqdeHgePJbOGExTrQsSwBiPV-GpsY2IizltuYGySfI7pLAedlrQnpGZahPuk5yVl9AP/pub?gid=1906528137&single=true&output=csv&rnd=" + (new Date().getTime());